<ng-container *ngIf="formGroup != null" [formGroup]="formGroup">
    <div *ngFor="let equipment of equipments; let i = index">
        <sc-checkbox-field formControlName="cb-{{equipment.id}}" [label]="'---' | translate:['dd.SUPPLEMENTARYEQUIPMENT.'+equipment.id+'.name',
        translationService.language]"></sc-checkbox-field>
    </div>
    <div *ngIf="!equipments || equipments.length === 0">{{ 'no euqipment defined' | translate:['tmc-common.ui.filter-admin.condition.has-supplementary-equipment.no-equipment-defined',
        translationService.language]}}</div>
</ng-container>